import { createGetFullKeyEndpointFromExisting } from '@lib';
import { getCustomerUsers } from './getCustomerUsers';

export const getAllUsers = createGetFullKeyEndpointFromExisting(getCustomerUsers);
